import React from 'react';
import { SiteBrandedLoader, BrandSpinnerRing, type SiteBrandedLoaderTone } from './SiteBrandedLoader';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  fullScreen?: boolean;
  tone?: SiteBrandedLoaderTone;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  className = '',
  fullScreen = true,
  tone = 'light',
}) => (
  <SiteBrandedLoader
    variant={fullScreen ? 'fullscreen' : 'section'}
    size={size}
    tone={tone}
    className={className}
  />
);

export { BrandSpinnerRing };
export default LoadingSpinner;
